/* eslint-disable max-lines */
export const PATIENT_OPTIONS = {
  queryKey: 'patients.options',
  title: 'Patient',
  placeholder: 'Search patient',
  icon: 'user-mono'
};

export const PROVIDER_OPTIONS = {
  queryKey: 'practitioners.options',
  title: 'Provider',
  placeholder: 'Search provider',
  icon: 'user-square-mono'
};

export const PATIENT_PRACTICE_OPTIONS = {
  queryKey: 'patient_practices.options',
  title: 'Practice',
  placeholder: 'Search practice',
  icon: 'user-2-mono'
};

export const PROVIDER_CLAIM_OPTIONS = {
  queryKey: 'providers_for_claims.options',
  title: 'Provider',
  placeholder: 'Search provider',
  icon: 'user-square-mono'
};

export const PAYER_OPTIONS = {
  queryKey: 'payers.options',
  title: 'Payer',
  placeholder: 'Search payer',
  icon: 'payers-mono'
};

export const CLAIM_OPTIONS = {
  title: 'Claim',
  placeholder: 'Search claim or claim md number',
  queryKey: 'claim_ids.options',
  icon: 'text-num-mono'
};

export const CLAIM_NUMBER_OPTIONS = {
  title: 'Claim number',
  placeholder: 'Search claim number',
  queryKey: 'claim_md_ids.options',
  icon: 'text-num-mono'
};

export const ERA_OPTIONS = {
  title: 'ERA',
  placeholder: 'Search ERA number',
  queryKey: 'era_ids.options',
  icon: 'text-num-mono'
};

export const EOB_OPTIONS = {
  title: 'EOB',
  placeholder: 'Search EOB number',
  queryKey: 'eob_ids.options',
  icon: 'text-num-mono'
};

export const SUPERBILL_OPTIONS = {
  title: 'Superbill',
  placeholder: 'Search superbill',
  queryKey: 'superbill_ids.options',
  icon: 'text-num-mono'
};

export const INVOICE_OPTIONS = {
  title: 'Invoice',
  placeholder: 'Search invoice',
  queryKey: 'invoice_ids.options',
  icon: 'text-num-mono'
};

export const PAYMENT_OPTIONS = {
  title: 'Payment',
  placeholder: 'Search payment',
  queryKey: 'payment_ids.options',
  icon: 'text-num-mono'
};

export const EXTERNAL_INVOICE_OPTIONS = {
  title: 'External invoice',
  placeholder: 'Search external invoice',
  queryKey: 'external_invoice_ids.options',
  icon: 'text-num-mono'
};

export const BILLING_PROVIDER_OPTIONS = {
  title: 'Billing provider',
  placeholder: 'Search billing provider',
  queryKey: 'billing_providers.options',
  icon: 'user-2-mono'
};

export const RENDERING_PROVIDER_OPTIONS = {
  title: 'Rendering provider',
  placeholder: 'Search rendering provider',
  queryKey: 'rendering_providers.options',
  icon: 'user-square-mono'
};

export const FACILITY_PROVIDER_OPTIONS = {
  title: 'Facility provider',
  placeholder: 'Search facility provider',
  queryKey: 'facility_providers.options',
  icon: 'building-mono'
};

export const PRODUCT_CODE_OPTIONS = {
  title: 'Product code',
  placeholder: 'Search product code',
  queryKey: 'product_codes.options',
  icon: 'text-num-mono'
};

export const CPT_CODE_OPTIONS = {
  title: 'CPT® code',
  queryKey: 'cpt_codes.options',
  placeholder: 'Search CPT® code',
  icon: 'cpt-codes-mono'
};

export const CDT_CODE_OPTIONS = {
  title: 'CDT code',
  queryKey: 'cdt_codes.options',
  placeholder: 'Search CDT code',
  icon: 'cpt-codes-mono'
};

export const ICD_CODE_OPTIONS = {
  title: 'ICD code',
  placeholder: 'Search ICD code',
  queryKey: 'icd10_codes.options',
  icon: 'icd-codes-mono'
};

export const SERVICE_OPTIONS = {
  queryKey: 'services.options',
  title: 'Services',
  placeholder: 'Search service',
  icon: 'star-1-mono',
  allowed_operators: ['is any of', 'is not', 'is']
};

export const PRODUCT_OPTIONS = {
  queryKey: 'products.options',
  title: 'Products',
  placeholder: 'Search product',
  icon: 'pill-mono',
  allowed_operators: ['is any of', 'is not', 'is']
};

export const APPOINTMENT_RESOURCE_OPTIONS = {
  title: 'Appointment resources',
  placeholder: 'Search resources',
  icon: 'menu-board-mono',
  queryKey: 'resources.options',
  allowed_operators: ['is any of', 'is not', 'is']
};

export const APPOINTMENT_TAG_OPTIONS = {
  title: 'Appointment tags',
  placeholder: 'Search tags',
  icon: 'tag-mono',
  queryKey: 'appointment_tags.options',
  allowed_operators: ['is any of', 'is not', 'is']
};

export const PRODUCT_CATEGORY_OPTIONS = {
  title: 'Product category',
  placeholder: 'Search category',
  queryKey: 'product_categories.options',
  icon: 'list-unordered-mono'
};

export const PRACTICE_ROLE_OPTIONS = {
  title: 'Practice role',
  placeholder: 'Search role',
  queryKey: 'practice_roles.options',
  icon: 'user-square-mono',
  allowed_operators: ['is any of', 'is not', 'is']
};

export const TAG_CHARTS_OPTIONS = {
  title: 'Tag',
  placeholder: 'Search tag',
  queryKey: 'tags.options',
  icon: 'tag-mono',
  allowed_operators: ['is any of', 'is not', 'is'],
  params: { kind: 'chart' }
};

export const TAG_FAX_OPTIONS = {
  title: 'Tag',
  placeholder: 'Search tag',
  queryKey: 'tags.options',
  icon: 'tag-mono',
  allowed_operators: ['is any of', 'is not', 'is'],
  params: { kind: 'fax' }
};

export const TAG_APPOINTMENT_OPTIONS = {
  title: 'Tag',
  placeholder: 'Search tag',
  queryKey: 'tags.options',
  icon: 'tag-mono',
  allowed_operators: ['is any of', 'is not', 'is'],
  params: { kind: 'appointment' }
};

export const TAG_DOCUMENT_OPTIONS = {
  title: 'Tag',
  placeholder: 'Search tag',
  queryKey: 'tags.options',
  icon: 'tag-mono',
  allowed_operators: ['is any of', 'is not', 'is'],
  params: { kind: 'document' }
};

export const FORM_OPTIONS = {
  title: 'Form',
  placeholder: 'Search form',
  queryKey: 'forms.options',
  icon: 'tick-square-mono',
  allowed_operators: ['is any of', 'is not', 'is']
};

export const FORM_TYPE_OPTIONS = {
  title: 'Form type',
  placeholder: 'Search form type',
  queryKey: 'form_types.options',
  icon: 'list-unordered-mono',
  allowed_operators: ['is any of', 'is not', 'is']
};

export const MEMBER_OPTIONS = {
  title: 'Member',
  placeholder: 'Search member',
  queryKey: 'members.options',
  icon: 'user-mono'
};

export const TAG_INVOICE_OPTIONS = {
  title: 'Tag',
  placeholder: 'Search tag',
  queryKey: 'tags.options',
  icon: 'tag-mono',
  allowed_operators: ['is any of', 'is not', 'is'],
  params: { kind: 'invoice' }
};

export const TAG_CLAIM_OPTIONS = {
  title: 'Tag',
  placeholder: 'Search tag',
  queryKey: 'tags.options',
  icon: 'tag-mono',
  allowed_operators: ['is any of', 'is not', 'is'],
  params: { kind: 'claim' }
};

export const SPECIALTY_OPTIONS = {
  title: 'Specialty',
  placeholder: 'Search specialty',
  queryKey: 'specialties.options',
  icon: 'user-square-mono',
  allowed_operators: ['is any of', 'is not', 'is']
};

export const DOCUMENT_CATEGORY_OPTIONS = {
  title: 'Category',
  icon: 'list-unordered-mono',
  placeholder: 'Search document category',
  queryKey: 'document_categories.options',
  allowed_operators: ['is any of', 'is not', 'is']
};

export const KIOSK_OPTIONS = {
  title: 'Kiosk',
  placeholder: 'Search kiosk',
  queryKey: 'kiosks.options',
  icon: 'text-num-mono',
  allowed_operators: ['is any of', 'is not', 'is']
};

export const PATIENT_FORM_OPTIONS = {
  title: 'Form',
  placeholder: 'Search form',
  queryKey: 'patient_forms.options',
  icon: 'tick-square-mono',
  allowed_operators: ['is any of', 'is not', 'is']
};

export const ADMIN_ROLES_OPTIONS = {
  queryKey: 'admin_roles.options',
  title: 'Roles',
  placeholder: 'Search roles',
  icon: 'user-mono',
  allowed_operators: ['is', 'is not', 'is any of']
};

export const ADMIN_PRACTICE_OPTIONS = {
  queryKey: 'practices.options',
  title: 'Practice',
  placeholder: 'Search practice',
  icon: 'practice-mono',
  allowed_operators: ['is', 'is not', 'is any of', 'contains', 'does not contain']
};

export const ADMIN_PRACTICE_ID_OPTIONS = {
  queryKey: 'practice_ids.options',
  title: 'Practice ID',
  placeholder: 'Search practice ID',
  icon: 'practiceiqueue-filled',
  allowed_operators: ['is', 'is not', 'is any of', 'contains', 'does not contain']
};

export const ADMIN_PATIENT_OPTIONS = {
  queryKey: 'patients.options',
  title: 'Patient',
  placeholder: 'Search patient',
  icon: 'personal-id-card-mono',
  allowed_operators: ['is', 'is not', 'is any of', 'contains', 'does not contain']
};

export const ADMIN_PATIENT_ID_OPTIONS = {
  queryKey: 'admin_patient_ids.options',
  title: 'Patient ID',
  placeholder: 'Search patient ID',
  icon: 'user-mono',
  allowed_operators: ['is', 'is not', 'is any of', 'contains', 'does not contain']
};

export const ADMIN_TRANSACTION_ID_OPTIONS = {
  queryKey: 'admin_transaction_ids.options',
  title: 'Transaction ID',
  placeholder: 'Search transaction ID',
  icon: 'text-num-mono',
  allowed_operators: ['is', 'is not', 'is any of', 'contains', 'does not contain']
};

export const ADMIN_MEMBERS_OPTIONS = {
  queryKey: 'admin_members.options',
  title: 'Members',
  placeholder: 'Search members',
  icon: 'user-mono',
  allowed_operators: ['is', 'is not', 'is any of', 'contains', 'does not contain']
};
